import { Box, styled } from '@mui/material';

export const PanelHeaderBox = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 12px',
  borderBottom: '1px solid #eee',
  height: 60
});
